module.exports = __webpack_public_path__ + "static/project_portfolio-f6e38a0d9b274416647d20eb17194e39.svg";